module.exports = __webpack_public_path__ + "media/images/rank/gold-sm-757eff4bd48a727277644a68b600dbac.svg";